export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14625.493fc404.jpg";